import { render } from "./SurveyEndStarted.vue?vue&type=template&id=1deadb7b"
const script = {}

import exportComponent from "/home/d6338/zsurvey-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__